<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 id="tituloPainel" class="card-dados__titulo mb-0">Listagem</h3>

        <v-data-table :headers="headersTabela" :items="value" hide-actions
                      class="az-table-list tabela-itens-edicao">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.identificacaoSequencial }}
                </td>
                <td>
                    {{ props.item.codigo }}
                </td>
                <td ref="coluna_descricao">
                    <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
                </td>
                <td>
                    <v-tooltip top v-if="props.item.motivo" class="botao-motivo">
                        <a slot="activator">
                            {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                            <i class="fas fa-comment" aria-hidden="true"/>
                        </a>
                        {{ props.item.motivo }}
                    </v-tooltip>
                    <span v-else>
                        {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                    </span>
                </td>
                <td>
                    <div class="az-checkbox">
                        <v-radio-group id="checkboxExclusividade" row class="ajuste-fundo"
                                       @click.native.stop="$emit('alteracaoExclusividadeItem', {id: props.item.id, novoValor: props.item.porteExclusivo} )"
                                       v-model="props.item.porteExclusivo">
                            <v-radio label="Sim" :value="true" color="primary"></v-radio>
                            <v-radio class="mr-0" label="Não" :value="false" color="primary"></v-radio>
                        </v-radio-group>
                    </div>
                </td>
                <td align="right">
                    {{ props.item.unidade }}
                </td>
                <td align="right">
                    {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
                </td>
                <td v-if="possuiValorReferencia" align="right">
                    {{ props.item.valorEstimado | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                </td>
                <td align="right" v-if="possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto">
                    {{ props.item.totalEstimado | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                </td>
                <td class="table-actions" align="center">
                    <v-tooltip top>
                        <a id="botaoLixeira" slot="activator"
                           @click="$emit('excluirItemSemLote', props.item.id, 'item')">
                            <i class="fas fa-trash-alt" aria-hidden="true"/>
                        </a>
                        Excluir
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>

        <div class="total total-mobile" v-if="possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto && value.length > 1">
            <p>
                <strong>Total: </strong> {{ total | cdCurrency(prefix, casasDecimais)}}{{suffix}}
            </p>
        </div>
    </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import {situacoesItensELotes} from '@/core/constants'

export default {
    name: 'PainelItemEdicao',
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        criterioJulgamento:{
            type: String
        },
        prefixoValor:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        possuiValorReferencia: {
            type: Boolean,
            default: null
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            situacoesItensELotes,
            tamanho: null,
        }
    },
    computed: {
        headersTabela(){
            return [
                {
                    value: 'sequencia',
                    text: 'Seq',
                    sortable: true,
                    width: '5%',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    value: 'codigo',
                    text: 'Código',
                    sortable: false,
                    width: '5%',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    value: 'descricao',
                    text: 'Descrição',
                    sortable: false,
                    width: '30%',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    value: 'situacao',
                    text: 'Situação',
                    sortable: false,
                    width: '10%',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    text: 'Exclusivo',
                    align: 'left',
                    sortable: false,
                    width: '10%',
                    class: 'primary--text'
                },
                {
                    value: 'unidade',
                    align: 'right',
                    text: 'Unidade',
                    sortable: false,
                    width: '8%',
                    class: 'primary--text'
                },
                {
                    value: 'quantidade',
                    align: 'right',
                    text: 'Qtd',
                    sortable: false,
                    width: '5%',
                    class: 'primary--text'
                },
                ... this.possuiValorReferencia ? [{
                    value: 'valorEstimado',
                    align: 'right',
                    text: !this.isCriterioJulgamentoMaiorDesconto ? 'Estimado Unit. (R$)' : 'Estimado Unit. (%)',
                    sortable: false,
                    width: '10%',
                    class: 'primary--text pb-5'
                }] : [],
                ... this.possuiValorReferencia && !this.isCriterioJulgamentoMaiorDesconto ? [{
                    value: 'estimado_total',
                    align: 'right',
                    text: 'Estimado Total (R$)',
                    sortable: false,
                    width: '10%',
                    class: 'primary--text'
                }] : [],
                {
                    sortable: false,
                    text: 'Ações',
                    width: '5%',
                    class: 'primary--text',
                    align: 'center'
                }
            ]
        },
        total() {
            let total = 0
            this.value.forEach(item => {
                if (item.totalEstimado > 0) {
                    total += item.totalEstimado
                }
            })
            return total
        },
        ...mapState(['loki']),
        prefix(){
            return this.prefixoValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixoValor === '%' ? '%' : ''
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    methods: {
        pegarTamanho() {
            this.tamanho = .072 * window.innerWidth
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style scoped lang="stylus">
    .tabela-itens-edicao, .tabela-itens-manual-edicao
        padding 16px

        .table-actions a
            margin-left 0

    @media (max-width 720px)
        .az-table-list
            &.tabela-itens-edicao, &.tabela-itens-manual-edicao
                padding 0

                .table-actions a i
                    font-size 18px !important

                td:nth-of-type(1):before
                    content "Sequência:"

                td:nth-of-type(6)
                    text-align left

                td:nth-of-type(7)
                    text-align left

                td:nth-of-type(8)
                    text-align left

            &.tabela-itens-edicao
                td:nth-of-type(2):before
                    content "Código:"

                td:nth-of-type(3):before
                    content "Descrição:"

                td:nth-of-type(4):before
                    content "Situação:"

                td:nth-of-type(5):before
                    content "Exclusivo:"

                td:nth-of-type(6):before
                    content "Unidade:"

                td:nth-of-type(7):before
                    content "Quantidade:"

                td:nth-of-type(8):before
                    content "Estimado Unitário (R$):"

                td:nth-of-type(9):before
                    content "Estimado Total (R$):"

                td:nth-of-type(10):before
                    display none

                td:nth-of-type(9)
                    text-align left

            &.tabela-itens-manual-edicao
                td:nth-of-type(2):before
                    content "Descrição:"

                td:nth-of-type(3):before
                    content "Situação:"

                td:nth-of-type(4):before
                    content "Exclusivo:"

                td:nth-of-type(5):before
                    content "Unidade:"

                td:nth-of-type(6):before
                    content "Quantidade:"

                td:nth-of-type(7):before
                    content "Estimado Unitário (R$):"

                td:nth-of-type(8):before
                    content "Estimado Total (R$):"

                td:nth-of-type(9):before
                    display none

                td:nth-of-type(5)
                    text-align left
</style>
